module.exports = __webpack_public_path__ + "img/beer_id-9.d669842f.png";